<div class="sidebar">
  <div *ngFor="let item of navigationMenu"
    class="sidebar-item"
    [ngClass]="{'router-link-active': linkActive.isActive}"
    [routerLink]="item.routerLink"
    routerLinkActive
    #linkActive="routerLinkActive">
    <mat-icon [color]="linkActive.isActive ? 'accent' : 'primary'"
      [svgIcon]="item.svgIcon || undefined"
      [style]="{width: item.iconSize || '24px',height:item.iconSize || '24px'}">{{item.icon}}</mat-icon>
  </div>
</div>